const createStyleSheet = (href) => {
    let link = document.createElement("link");
    link.setAttribute("href", href);
    link.setAttribute("rel", "stylesheet");
    return link;
};
const createStyleSheets = (hrefs) => {
    return hrefs.map(createStyleSheet);
};

const handleAdoptedStyleSheets = async (css, owner) => {
    if (!css) return []
    if (css instanceof Promise) {
        css = await css
    }
    if (css instanceof CSSStyleSheet) {
        return [css]
    }

    if (typeof css === 'string') {
        let styleSheet = new CSSStyleSheet()
        styleSheet.replaceSync(css)
        return [styleSheet]
    }
    if (css instanceof Array) {
        let styleSheets = []
        for (let styleSheet of css) {
            styleSheets = styleSheets.concat(await handleAdoptedStyleSheets(styleSheet, owner))
        }
        return styleSheets
    }
    if (typeof css == "function") {
        return handleAdoptedStyleSheets(await css.call(owner), owner)
    }

    if (css.default) {
        // [object Module]
        return handleAdoptedStyleSheets(css.default, owner)
    }
    return []
}

const handleStyleSheets = async (css, owner) => {
    if (!css) return []
    if (css instanceof Promise) {
        css = await css
    }
    if (typeof css === 'string') {
        return [css]
    }
    if (css instanceof Array) {
        let styleSheets = []
        for (let styleSheet of css) {
            styleSheets.push(... (await handleStyleSheets(styleSheet, owner)))
        }
        return styleSheets
    }
    if (typeof css == "function") {
        return handleStyleSheets(await css.call(owner), owner)
    }
    if (css.default) {
        // [object Module]
        return handleStyleSheets(css.default, owner)
    }
    return []
}

export { createStyleSheet, createStyleSheets, handleAdoptedStyleSheets, handleStyleSheets }